import { Component, EventEmitter, HostListener, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NavigationService } from '../../../core/service/navigation.service';
import { SidebarItemDefinition } from '../../../common/model/sidebar-item';
import { ViewType } from '../dashboard-item/dashboard-item.component';

@Component({
    selector: 'app-dashboard-new-menu-item',
    templateUrl: './dashboard-new-menu-item.component.html',
    styleUrls: ['./dashboard-new-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardNewMenuItemComponent implements OnInit {
  constructor(private _navigation: NavigationService) {}

  updates: number;
  @Input() definition: SidebarItemDefinition;
  @Input() viewType: ViewType;
  @Output() menuItemClick = new EventEmitter<void>();

  private _showMenu: boolean;

  get showMenu(): boolean {
    if (!this.definition || !this.definition.menuDefinition || this.definition.menuDefinition.length === 0) {
      return false;
    }
    return this._showMenu;
  }

  set showMenu(value: boolean) {
    this._showMenu = value;
  }

  ngOnInit() {
    console.log(this.definition);
  }

  openMenu() {
    if (this.definition.hasMenu) {
      this.showMenu = !this.showMenu;
    } else {
      this.menuItemClick.emit();
      this._navigation.navigate([this.definition.href]);
    }
  }

  onSubMenuClick() {
    this.menuItemClick.emit();
  }
}
